import angular, { ILogService } from 'angular'
import { NotificacionService } from '../../../../_panel/module/uni-base/services/NotifService'
import { AccesoDatos } from '../../../comun/services/acceso-datos'
import { BloqueForm } from '../../../data/bloque-form'
import { Formulario } from '../../../data/formulario'

class TarjetaBloqueComponentCtrl {
  formular!: Formulario
  bloque!: BloqueForm

  noactivo: boolean
  editar: boolean = false

  onAdd: () => void

  constructor(
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[TarjetaBloqueComponentCtrl] onInit')

    this.noactivo = !!this.bloque.data.noactivo
  }

  guardarBloque() {
    this.bloque.beforeSave()

    this.AccesoDatos.EdicionFormular_CLIENT.nuevoBloque(this.formular.data.idform, this.bloque).then((response) => {
      this.bloque.update(response)
    })
  }

  incluirPregunta() {
    this.onAdd()
  }

  upBloqueFormulario() {}

  downBloqueFormulario() {}

  removeBloqueFormulario() {
    this.bloque.eliminar = !this.bloque.eliminar
  }

  restoreBloqueFormulario() {
    this.bloque.restaurar = !this.bloque.restaurar
  }

  editBloque() {
    this.editar = true
  }
}

angular.module('candidato').component('tarjetaBloque', {
  bindings: {
    formular: '<',
    bloque: '<',
    onAdd: '&',
  },
  controller: TarjetaBloqueComponentCtrl,
  template: require('./tarjeta-bloque.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/tarjeta-bloque/tarjeta-bloque.component.html"
})
